// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__jUHtP","user":"Navbar_user__N4TjW","active":"Navbar_active__0kdox","slide-right":"Navbar_slide-right__zWLe5"};